import { SideNavInterface } from "../../interfaces/side-nav.type";
import { DASHBOARD_ROUTES, FEE_ROUTES, FULL_ROUTES, INVESTOR_ROUTES, MAIL_ROUTES, PRODUCT_ROUTES, QUERY_ROUTES, TRANSACTION_ROUTES } from "./side-nav-routes.config";

export const ADMIN_ROUTES: SideNavInterface[] = [...FULL_ROUTES];
export const SUB_ADMIN_ROUTES: SideNavInterface[] = [
  ...DASHBOARD_ROUTES,
  ...FEE_ROUTES,
  ...MAIL_ROUTES
];
export const EMPLOYEE_ROUTES: SideNavInterface[] = [
  ...INVESTOR_ROUTES,
  ...PRODUCT_ROUTES,
  ...TRANSACTION_ROUTES
];
export const DEVELOPER_ROUTES: SideNavInterface[] = [
  ...DASHBOARD_ROUTES, 
  ...QUERY_ROUTES,
  ...FEE_ROUTES
];
export const FEE_VIEWER_ROUTES: SideNavInterface[] = [
  ...DASHBOARD_ROUTES,
  ...FEE_ROUTES
];
